<template>
  <div class="index-box">
    <div class="jieshao">
      <div
        class="imgdiv"
        :style="{ backgroundImage: `url(${characterInfo.imgPath})` }"
      ></div>
      <span class="name">{{ characterInfo.personName }}</span>
      <span class="post">{{ characterInfo.post }}</span>
      <div class="jjTitle" v-if="jianjieList != ''">人物简介</div>
      <!-- <span class="jianjie">{{ characterInfo.jianjie }}</span> -->
      <div class="jianjie" v-if="jianjieList != ''">
        <div v-for="(segment, index) in jianjieList" :key="index">
          {{ segment }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      id: this.$route.query.id, //人物Id
      characterInfo: {}, //人物信息
      jianjieList: [],
    };
  },
  created() {
    this.getCharacterInfo();
  },
  methods: {
    async getCharacterInfo() {
      const result = await this.$http.get("/amPerson/getDetailEx", {
        params: { id: this.id },
      });
      console.log("杰出人物详情", result.data);
      this.characterInfo = result.data;

      // 使用split方法根据关键字分割字符串
      const content = result.data.jianjie.split("\n");
      // 重新组合分段，包含关键字
      const contentList = [];
      for (let i = 0; i < content.length; i++) {
        contentList.push(content[i]);
      }
      this.jianjieList = contentList;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  image-rendering: -webkit-optimize-contrast;
  .jieshao {
    display: flex;
    flex-direction: column;
    width: 95vw;
    // height: 90vh;
    background: #fff;
    margin-left: 2.5vw;
    margin-top: 80px;
    border-radius: 10px;
    border: 1px solid #ededed;
    box-shadow: 0px 0px 10px #ffffff;

    .imgdiv {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 130px;
      height: 130px;
      border-radius: 50%;
      background-size: cover;
      overflow: hidden;
      background-position: center;
      // // background-size: 100% 100%;
      // // background-repeat: no-repeat;

      // // image-rendering: -webkit-optimize-contrast;
      // // background-size: cover;
      // background-size: 100% 100%;
      //   image-rendering: -moz-crisp-edges;
      //   image-rendering: -o-crisp-edges;
      //   image-rendering: -webkit-optimize-contrast;
      //   image-rendering: crisp-edges;
      //   -ms-interpolation-mode: nearest-neighbor;
      margin-top: -60px;
      margin-left: 33%;
      margin-bottom: 10px;
    }
    .name {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      text-align: center;
      font-size: 1.2rem;
      font-weight: 600;
      color: #000;
      margin-bottom: 5px;
    }
    .post {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 90vw;
      margin-left: 2.5vw;
      text-align: center;
      font-size: 1.1rem;
      font-weight: 500;
      color: #676767;
      margin-bottom: 10px;
    }
    .jjTitle {
      margin-left: 2.5vw;
      font-size: 1.2rem;
      font-weight: 600;
      color: #000;
      margin-bottom: 10px;
    }
    .jianjie {
      // position: absolute;
      display: flex;
      width: 90vw;
      font-size: 1rem;
      font-weight: 500;
      line-height: 25px;
      color: #747474;
      padding: 0 1rem 0 0.7rem;
      text-indent: 4ch;
      text-align: justify;
      margin-bottom: 15px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/CharacterAlumniDetails.vue